import React from "react";
import { Col, Row, Popconfirm, Table, Form, Tooltip, Icon, Modal } from "antd";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import BunkeyAPI from "../../../api/BunkeyAPI";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  DeleteOutlined,
  FormOutlined
} from "@ant-design/icons";
import { injectIntl } from "react-intl";
import { deleteClient } from "../../../actions/ClientAction";
import ListSearcher from "../../searcher/ListSearcher";
import ClientReport from "./ClientReport";
import { getWithDrawer } from "../../../utils";
import EditClient from "../../create-client/EditClient";
import {
  getTypeClients,
  getTypeBusinessClients
} from "../../../actions/ClientsAction";

export class ClientRegister extends React.Component {
  constructor(props) {
    super(props);

    const { intl } = this.props;

    const limit = 10;

    this.state = {
      showEditClient: false,
      isFetching: true,
      activePage: 1,
      fNameOrEmail: "",
      userSelected: "",
      page: 1,
      count: 0,
      limit: limit,
      orderBy: "name",
      orderDir: "desc",
      clients: [],
      data: [],
      colorCreationdate: "",
      paginationColor: {
        10: limit === 10 ? "#eaeaea" : "",
        20: limit === 20 ? "#eaeaea" : "",
        40: limit === 40 ? "#eaeaea" : "",
        60: limit === 60 ? "#eaeaea" : "",
        80: limit === 80 ? "#eaeaea" : "",
        100: limit === 100 ? "#eaeaea" : ""
      },
      iconPaginationColor: {
        10: limit === 10,
        20: limit === 20,
        40: limit === 40,
        60: limit === 60,
        80: limit === 80,
        100: limit === 100
      }
    };

    this.columns = [
      {
        title: "Cliente",
        key: "client",
        render: ({ client }) => (client && client ? client : "")
      },
      {
        title: "Email",
        key: "email",
        dataIndex: "email"
      },
      {
        title: "Almacenamiento",
        key: "contractedSpace",
        dataIndex: "contractedSpace"
      },
      {
        title: "Usuarios",
        key: "contractedUsers",
        dataIndex: "contractedUsers"
      },
      {
        title: "Modulos Activos",
        key: "modules",
        dataIndex: "modules",
        render: row => {
          const mod = row.map((m, k) => {
            if (m.activate === true) {
              return (
                <div
                  key={k}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span style={{ marginRight: 5 }}>
                    {intl.formatMessage({ id: m.name })}
                  </span>
                  <CheckCircleFilled style={{ color: "#4EAF51" }} />
                </div>
              );
            } else {
              return (
                <div
                  key={k}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span style={{ marginRight: 5 }}>
                    {intl.formatMessage({ id: m.name })}
                  </span>
                  <CheckCircleOutlined />
                </div>
              );
            }
          });
          return mod.map((r, k) => r);
        }
      },
      {
        title: intl.formatMessage({ id: "action" }),
        dataIndex: "action",
        render: row => {
          return (
            <div>
              <a
                href
                style={{ paddingRight: "10px" }}
                onClick={this.handleShowEditClient}
              >
                <FormOutlined style={{ color: "#3598CD" }} />
              </a>

              <Popconfirm
                placement="topLeft"
                title={intl.formatMessage({ id: "delete_client_question" })}
                onConfirm={this.handleDeleteClient}
                okText={intl.formatMessage({ id: "yes" })}
                cancelText="No"
              >
                <a href>
                  <DeleteOutlined style={{ color: "#3598CD" }} />
                </a>
              </Popconfirm>
            </div>
          );
        }
      }
    ];
  }

  componentDidMount() {
    this.props.getTypeClients();
    this.props.getTypeBusinessClients();
    this.handleGetData();
  }

  componentDidUpdate(prevProps) {
    const { clientUpdate, searchClient } = this.props;
    if (clientUpdate && clientUpdate !== prevProps.clientUpdate) {
      setTimeout(() => {
        this.setState(
          {
            isFetching: true
          },
          this.handleGetData
        );
      }, 1000);
    }

    if (searchClient !== false && searchClient !== prevProps.searchClient) {
      this.handleGetData();
    }
  }

  handleGetData = () => {
    const { filter } = this.props.stateFromActivity;
    const { page, limit, orderBy, orderDir, fNameOrEmail } = this.state;
    let order = {
      //field: [orderBy],
      field: [orderBy],
      type: orderDir,
      limit: limit,
      page: page
    };

    let search = [];

    if (fNameOrEmail.trim() !== "") {
      search = [
        ...search,
        {
          name: fNameOrEmail.trim()
        }
      ];
    }

    if (filter.clientType !== "all") {
      search = [
        ...search,
        {
          clientType: filter.clientType
        }
      ];
    }

    if (filter.businessType !== "all") {
      search = [
        ...search,
        {
          businessType: filter.businessType
        }
      ];
    }

    let modules = [];
    for (const key in filter.modules) {
      if (filter.modules[key] === true) {
        modules.push(key);
      }
    }

    if (modules.length >= 1) {
      search = [
        ...search,
        {
          field: "modules",
          type: "in",
          value: modules ? modules : []
        }
      ];
    }

    let url = `admin/clients?order=${JSON.stringify(order)}`;
    if (search.length > 0) {
      url = `admin/clients?search=${JSON.stringify(
        search
      )}&order=${JSON.stringify(order)}`;
    }

    BunkeyAPI({
      url: url,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          this.setState({
            data: resp.data.map(dt => {
              return {
                _id: dt._id,
                client: dt.name,
                email: dt.email,
                clientType: dt.clientType,
                businessType: dt.businessType,
                contractedSpace: dt.contractedSpace,
                contractedUsers: dt.contractedUsers,
                modules: dt.modules,
                companyName: dt.name,
                dartCustomField: dt.dartCustomField,
                media: dt.media,
                statusAsset: dt.statusAsset,
                dni: dt.dni,
                agent: dt.agent,
                phone: dt.phone
              };
            }),

            isFetching: false
          });
        }
      })
      .catch(err => {
        console.log("mount err: ", err);
      });
  };

  filterByNameOrEmail = e => {
    const { value } = e.target;
    this.setState({ fNameOrEmail: value ? value.toString().trim() : "" });
  };

  handleOnSearch = () => {
    this.setState(
      {
        fNameOrEmail: ""
      },
      this.handleGetData
    );
  };

  handleOnchageSearch = e => {
    this.setState(
      {
        fNameOrEmail: e.target.value
      },
      this.handleGetData
    );
  };

  handleOnPageChange = value => {
    this.setState(
      {
        isFetching: true,
        activePage: value
      },
      this.handleGetData
    );
  };
  //Redireccionando al formulario Clientes
  handleShowCreateClient = () => {
    this.props.history.push({
      pathname: "/home/clients",
      state: { actived: true }
    });
  };

  handleShowEditClient = () => {
    const { userSelected } = this.state;

    this.setState({
      showEditClient: true,
      editData: userSelected
    });
  };

  SendDataToClient(key) {
    this.setState({
      userSelected: key
    });
  }

  handleDeleteClient = () => {
    const { userSelected } = this.state;
    this.props.deleteClient(userSelected._id);
  };

  handlePaginationNumber = limit => {
    this.setState(
      {
        isFetching: true,
        page: 1,
        limit: limit,
        paginationColor: { [limit]: "#eaeaea" },
        iconPaginationColor: {
          [limit]: true
        }
      },
      this.handleGetData
    );
  };

  handleOrderBy = (orderBy, orderDir) => {
    this.setState(
      {
        orderBy,
        orderDir,
        isFetching: true,
        page: 1
      },
      this.handleGetData
    );
    if (orderBy === "createdAt" && orderDir === "asc")
      this.handleActive("createdAt");
    else if (orderBy === "createdAt" && orderDir === "desc")
      this.handleActive("-createdAt");
    else if (orderBy === "name" && orderDir === "asc")
      this.handleActive("name");
    else if (orderBy === "name" && orderDir === "desc")
      this.handleActive("-name");
  };

  handleActive = orderBy => {
    if (orderBy === "-createdAt") {
      this.setState({
        colorCreatedAt: "#eaeaea",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "",
        iconCreatedAt: true,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: false
      });
    } else if (orderBy === "createdAt") {
      this.setState({
        colorCreatedAt: "",
        colorCreationdate: "#eaeaea",
        colorAZ: "",
        colorZA: "",
        iconCreatedAt: false,
        iconCreationdate: true,
        iconAZ: false,
        iconZA: false
      });
    } else if (orderBy === "name") {
      this.setState({
        colorCreatedAt: "",
        colorCreationdate: "",
        colorAZ: "#eaeaea",
        colorZA: "",
        iconCreatedAt: false,
        iconCreationdate: false,
        iconAZ: true,
        iconZA: false
      });
    } else if (orderBy === "-name") {
      this.setState({
        colorCreatedAt: "",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "#eaeaea",
        iconCreatedAt: false,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: true
      });
    }
  };

  handleHideEditClient = () => {
    this.setState({ showEditClient: false });
  };

  render() {
    const {
      data,
      showEditClient,
      editData,
      isFetching,
      activePage,
      limit,
      fNameOrEmail,
      //colorCreationdate,
      //colorCreatedAt,
      colorAZ,
      colorZA,
      //iconCreationdate,
      //iconCreatedAt,
      iconAZ,
      iconZA,
      iconPaginationColor
    } = this.state;

    const { intl, workclient, orderBy } = this.props;

    /*let dataTable = null

    const removeAccents = (text) => {
      return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    dataTable = data
      .map((d) => {
        const rgx = new RegExp(removeAccents(fNameOrEmail).replace(/[^a-zA-Z0-9]/g, ''), 'gi')

        if (
          fNameOrEmail !== '' &&
          !rgx.test(removeAccents(d.email))
        )
          return null
        else return d
      })
      .filter((d) => d)*/

    return (
      <div className="container" style={{ marginTop: "40px" }}>
        <Row>
          <Col md={12} xs={24}>
            <Form layout="vertical" onSubmit={this.handleSubmit}>
              <Row type="flex" justify="space-between" gutter={16}>
                <Col style={{ marginBottom: "10px" }}>
                  <label>Buscar Cliente: </label>
                  <ListSearcher
                    client={workclient}
                    placeholder={intl.formatMessage({
                      id: "enter_text_to_search_for_client"
                    })}
                    loading={isFetching}
                    searchButtonText={intl.formatMessage({ id: "all" })}
                    filterByNameOrEmail={this.filterByNameOrEmail}
                    handleOnSearch={this.handleOnSearch}
                    fNameOrEmail={fNameOrEmail}
                    handleOnchageSearch={this.handleOnchageSearch}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
          <Col md={12} xs={24}>
            <div>
              <div className="title-bar">
                <ul>
                  <div
                    className="cHeaderContainer"
                    style={{ marginRight: "8px" }}
                  >
                    <Tooltip
                      placement="top"
                      title={intl.formatMessage({ id: "sort_assets" })}
                    >
                      <li>
                        <img alt="asset" src="/images/icons/order-icon.svg" />
                        <ul>
                          <li
                            className={orderBy === "name" ? "active" : ""}
                            style={{
                              backgroundColor: colorAZ,
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handleOrderBy("name", "asc");
                              //this.handleActive('name')
                            }}
                          >
                            <span
                              key="4"
                              title="name"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              A - Z
                            </span>
                            {iconAZ && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "120px" }}
                              />
                            )}
                          </li>
                          <li
                            className={orderBy === "-name" ? "active" : ""}
                            style={{
                              backgroundColor: colorZA,
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handleOrderBy("name", "desc");
                              //this.handleActive('-name')
                            }}
                          >
                            <span
                              key="5"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              Z - A
                            </span>
                            {iconZA && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "120px" }}
                              />
                            )}
                          </li>
                        </ul>
                      </li>
                    </Tooltip>
                    <Tooltip
                      placement="top"
                      title={intl.formatMessage({ id: "items_per_page" })}
                    >
                      <li>
                        <Icon
                          type="more"
                          style={{
                            color: "white",
                            fontSize: "20px",
                            marginTop: "2px",
                            display: "inline-block",
                            width: "100%"
                          }}
                        />
                        <ul style={{ width: "100px", marginLeft: "100px" }}>
                          <li
                            className={limit === 10 ? "active" : ""}
                            style={{
                              backgroundColor: this.state.paginationColor[10],
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handlePaginationNumber(10);
                              this.handleActive();
                            }}
                          >
                            <span
                              key="1"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              10
                            </span>
                            {iconPaginationColor[10] && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "28px" }}
                              />
                            )}
                          </li>
                          <li
                            className={limit === 20 ? "active" : ""}
                            style={{
                              backgroundColor: this.state.paginationColor[20],
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handlePaginationNumber(20);
                              this.handleActive();
                            }}
                          >
                            <span
                              key="1"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              20
                            </span>
                            {iconPaginationColor[20] && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "28px" }}
                              />
                            )}
                          </li>
                          <li
                            className={limit === 40 ? "active" : ""}
                            style={{
                              backgroundColor: this.state.paginationColor[40],
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handlePaginationNumber(40);
                              this.handleActive();
                            }}
                          >
                            <span
                              key="2"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              40
                            </span>
                            {iconPaginationColor[40] && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "28px" }}
                              />
                            )}
                          </li>
                          <li
                            className={limit === 60 ? "active" : ""}
                            style={{
                              backgroundColor: this.state.paginationColor[60],
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handlePaginationNumber(60);
                              this.handleActive();
                            }}
                          >
                            <span
                              key="3"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              60
                            </span>
                            {iconPaginationColor[60] && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "28px" }}
                              />
                            )}
                          </li>
                          <li
                            className={limit === 80 ? "active" : ""}
                            style={{
                              backgroundColor: this.state.paginationColor[80],
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handlePaginationNumber(80);
                              this.handleActive();
                            }}
                          >
                            <span
                              key="4"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              80
                            </span>
                            {iconPaginationColor[80] && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "28px" }}
                              />
                            )}
                          </li>
                          <li
                            className={limit === 100 ? "active" : ""}
                            style={{
                              backgroundColor: this.state.paginationColor[100],
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handlePaginationNumber(100);
                              this.handleActive();
                            }}
                          >
                            <span
                              key="5"
                              style={{
                                color: "#337ab7",
                                backgroundColor: "transparent",
                                boxSizing: "border-box",
                                textDecoration: "none",
                                fontSize: 14,
                                marginTop: "-5px"
                              }}
                            >
                              100
                            </span>
                            {iconPaginationColor[100] && (
                              <Icon
                                type="check"
                                style={{ marginLeft: "28px" }}
                              />
                            )}
                          </li>
                        </ul>
                      </li>
                    </Tooltip>
                  </div>
                </ul>
              </div>
              <div style={{ clear: "both" }}></div>
            </div>
          </Col>
        </Row>
        <div className="table-responsive">
          <Table
            rowKey="_id"
            onRow={row => ({
              onMouseEnter: () => {
                this.SendDataToClient(row);
              }
            })}
            loading={isFetching}
            bordered
            columns={this.columns}
            expandedRowRender={row => <ClientReport client={row} />}
            dataSource={data}
            pagination={{
              current: activePage,
              pageSize: limit,
              //total: count,
              onChange: this.handleOnPageChange
            }}
          />
        </div>
        <Modal
          title={intl.formatMessage({ id: "edit_client" })}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideEditClient}
          onClose={this.handleHideEditClient}
          visible={showEditClient}
          keyboard={true}
        >
          <EditClient
            editData={editData}
            activePage={activePage}
            handleHideEditClient={this.handleHideEditClient}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    clientUpdate: state.client.clientUpdate
  };
};

const mapDispatchToProps = {
  deleteClient,
  getTypeClients,
  getTypeBusinessClients
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientRegister))
);
